export default {"src":"/_next/static/media/arrow-down.6efd1d41.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};